import PropTypes from 'prop-types';
import React from 'react';
import MentionOptionComponent from "../../../editor-universal/common/mention-option-component/mention-option-component";
import BaseComponent from "../../../base-component/base-component";

class MentionComponent extends BaseComponent {

    constructor(props) {
        super(props);

        this._bind('onClick');
    }

    onClick(e) {
        e.stopPropagation();
    }

    render() {
        const { mention, children, className } = this.props;
        const modifiedMention = _.assign({},mention,{type:gd.const.editorLink.type.USER});
        return <MentionOptionComponent className={className} viewType="view" mention={modifiedMention}>{children}</MentionOptionComponent>
    }
}

module.exports = MentionComponent;